export default __webpack_public_path__ + "static/media/Amper-2022.cf638a45.svg";